import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ContactsFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import ContactsFormStepTwo from "./ContactsFormSteps/ContactsFormStepTwo";
import ContactsFormStepOne from "./ContactsFormSteps/ContactsFormStepOne";
import { useEffect, useState } from "react";

const ContactsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ...props.initialValues,
        contactType: Boolean(props.initialValues?.contactType)
          ? { value: props.initialValues?.contactType }
          : null,
        clientGuardian: Boolean(props.initialValues?.clientGuardian?.uuid)
          ? { value: props.initialValues?.clientGuardian?.uuid }
          : null,
      });
      return;
    }

    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ContactsForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ContactsFormStepOne {...formProps} {...props} />
              <ContactsFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ContactsForm;
